import { useEffect, useMemo, useState, useCallback, useRef } from "react";
import {
  AreaTitleBooth,
  CheckoutButton,
  CheckoutEmpty,
  CheckoutFooter,
  CheckoutItemsContainer,
  CheckoutPreview,
  Container,
  ContentContainer,
  Coupon,
  CouponButton,
  CouponContainer,
  CouponInput,
  Currency,
  ContainerBooth,
  FilterButton,
  FilterButtonsContainer,
  Header,
  Modal,
  ModalButton,
  ModalText,
  ModalWrapper,
  Nav,
  ProductChangeQty,
  ProductColumnHeader,
  ProductTableContainer,
  ProductTableGrid,
  ProductTableItem,
  ProductType,
  RedirectContractProducts,
  SearchInput,
  SubHeader,
  SubHeaderContainer,
  Title,
  AreaBooth,
} from "./styles";
import GoBackButton from "../../components/goBackButton";
import { FantasyNameAndContractBadge } from "../../components/badges";
import { FormattedMessage, useIntl } from "react-intl";
import SearchIcon from "../../components/Icons/search-icon";
import ChevronRight from "../../components/Icons/chevron-right";
import { BagIcon } from "../../components/Icons/bag";
import ProductInfo, { ProductInfoSkeleton } from "./components/ProductInfo";
import {
  AttentionIcon,
  CancelIcon,
  CouponIcon,
  MinusIcon,
  PlusIcon,
} from "./components/Icons";
import { useDispatch, useSelector } from "react-redux";
import {
  checkoutInfo,
  getContractProducts,
  getAvaliableProducts,
  updateAvaliableProducts,
  getContractInfo,
  createContractInfoPromise,
} from "../../../../redux/modules/staff-acess/actions";
import { Empty } from "./components/Empty";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import api from "../../../../service";
import generateHeaders from "../../../../utils/generateHeaders";
import getEcommerceErrorDescription from "../../../../utils/getEcommerceErrorDescription";
import { formatCurrency } from "./Checkout/components/PaymentMethods/utils";
import { SkeletonDiv } from "./components/ProductInfo/styles";
import { notification } from "antd";
import { formatNumberDecimalCoin } from "../../../../utils/currency";
import { useLocation } from "react-router-dom";

export default function StaffServiceSales() {
  const location = useLocation();
  const intl = useIntl();
  // Tipo de credencial vindo do botão "Adquirir Credencial" (enum, ex.: "EXHIBITOR").
  const credentialType = location.state?.credentialType;
  const fantasyname = localStorage.getItem("serviceFantasyname");
  const contractNumber = localStorage.getItem("serviceContractNumber");
  const eventId = localStorage.getItem("serviceEventId");
  const serviceOpportunityNumber = localStorage.getItem(
    "serviceOpportunityNumber"
  );
  const systemUserId = localStorage.getItem("serviceSystemUserId");

  // INFORMACP-4382 — a aba selecionada e identificada pelo categoryId (chave estavel vinda do
  // backend), nunca pelo titulo (texto livre por evento). "all" = aba "Todos".
  const [selectedCategoryId, setSelectedCategoryId] = useState("all");
  const { products, cartProducts, productsLoaded, currency } = useSelector(
    (state) => state.staff_access
  );
  const dispatch = useDispatch();
  const [search, setSearch] = useState("");
  const [booths, setBooths] = useState([]);
  useEffect(() => {
    if (contractNumber) {
      dispatch(getContractProducts({ contractNumber, systemUserId }));
    }
  }, [dispatch, contractNumber]);

  // Função para obter dados do contrato com await usando Redux
  const fetchContractInfoWithAwait = useCallback(async () => {
    if (serviceOpportunityNumber) {
      try {
        const contractData = await createContractInfoPromise(dispatch, {
          serviceOpportunityNumber,
        });

        let validBooths = [];
        if (
          contractData &&
          contractData.opportunity.booths &&
          Array.isArray(contractData.opportunity.booths)
        ) {
          validBooths = contractData.opportunity.booths.filter(
            (booth) =>
              booth !== null &&
              booth !== undefined &&
              typeof booth === "object" &&
              Object.keys(booth).length > 0 &&
              !(
                booth.boothNumber === null ||
                booth.boothNumber === undefined ||
                booth.boothNumber === ""
              )
          );
        }

        setBooths(validBooths);
        return contractData;
      } catch (error) {
        console.error("❌ Erro ao obter dados:", error);
        throw error;
      }
    }
  }, [dispatch, serviceOpportunityNumber]);

  useEffect(() => {
    if (serviceOpportunityNumber) fetchContractInfoWithAwait();
  }, [serviceOpportunityNumber, fetchContractInfoWithAwait]);

  useEffect(() => {
    if (!productsLoaded) {
      dispatch(getAvaliableProducts({ eventId, contractNumber }));
    }
  }, [contractNumber, dispatch, eventId, productsLoaded]);

  // INFORMACP-4382 — seleção inicial da aba a partir do tipo de credencial recebido na
  // navegação. Casa por credentialType (enum estável); em empate, escolhe o menor categoryId
  // (fallback determinístico para dados ambíguos, não é regra de negócio). Roda uma única vez,
  // após os produtos carregarem, e nunca sobrescreve uma troca manual posterior do usuário.
  const initialTabAppliedRef = useRef(false);
  useEffect(() => {
    if (initialTabAppliedRef.current || !productsLoaded) return;
    initialTabAppliedRef.current = true;

    if (!credentialType) return;

    const matchingCategoryId = products
      .map((p) => p.category)
      .filter((c) => c && c.credentialType === credentialType && c.id != null)
      .map((c) => c.id)
      .sort((a, b) => a - b)[0];

    if (matchingCategoryId != null) {
      setSelectedCategoryId(matchingCategoryId);
    }
  }, [productsLoaded, products, credentialType]);

  const filteredProducts = useMemo(() => {
    const byCategory =
      selectedCategoryId === "all"
        ? products
        : products.filter((p) => p.category?.id === selectedCategoryId);

    if (!search) return byCategory;

    const searchedTerm = search.toLowerCase().trim();
    return byCategory.filter((p) =>
      p.title[intl.locale].toLowerCase().includes(searchedTerm)
    );
  }, [search, selectedCategoryId, products, intl.locale]);

  return (
    <Container>
      <Nav>
        <GoBackButton
          noPosition
          href={"/staff-access/service-panel"}
          intlId="backToDashboard"
        />
        <FantasyNameAndContractBadge
          fantasyname={fantasyname}
          contractNumber={contractNumber}
        />
      </Nav>

      <Header>
        <AreaTitleBooth>
          <Title>
            <FormattedMessage id={"sales"} />
          </Title>

          {booths.length > 0 ? (
            <ContainerBooth>
              {booths.map((booth, index) => (
                <AreaBooth key={index}>
                  <div>
                    {intl.formatMessage({ id: "booth" })}: {booth.boothNumber}
                  </div>
                  <div>
                    {intl.formatMessage({ id: "area_" })}:{" "}
                    {formatNumberDecimalCoin(booth.area, intl.locale)}
                  </div>
                </AreaBooth>
              ))}
            </ContainerBooth>
          ) : (
            <ContainerBooth>
              <AreaBooth>
                <div>
                  {intl.formatMessage({ id: "opportunity_without_booth" })}
                </div>
              </AreaBooth>
            </ContainerBooth>
          )}
        </AreaTitleBooth>

        <SearchInput
          prefix={<SearchIcon />}
          placeholder={intl.formatMessage({
            id: "search",
          })}
          allowClear
          onChange={(e) => setSearch(e.target.value)}
        />
      </Header>

      <SubHeader>
        <ProductType>
          <FormattedMessage id={"productType"} />
        </ProductType>

        <SubHeaderContainer>
          <FilterButtons
            selectedCategoryId={selectedCategoryId}
            categories={products.map((p) => p.category)}
            setSelectedCategoryId={setSelectedCategoryId}
          />

          <RedirectToProducts />
        </SubHeaderContainer>
      </SubHeader>

      <ContentContainer>
        <ProductsTable
          productsToSell={products}
          productsLoaded={productsLoaded}
          data={filteredProducts}
        />
        <PreviewCheckout
          cartProducts={cartProducts}
          productsToSell={products}
          currency={currency}
        />
      </ContentContainer>
    </Container>
  );
}

function RedirectToProducts() {
  return (
    <RedirectContractProducts
      to={"/staff-access/services/sales/contract-products"}
    >
      <FormattedMessage id={"contractProducts"} />
      <ChevronRight />
    </RedirectContractProducts>
  );
}

function FilterButtons({
  categories = [],
  selectedCategoryId,
  setSelectedCategoryId,
}) {
  const intl = useIntl();

  // Abas identificadas e deduplicadas por categoryId; o título é apenas rótulo visual.
  const uniqueCategories = useMemo(() => {
    const byId = new Map();
    categories.forEach((c) => {
      if (c && c.id != null && !byId.has(c.id)) byId.set(c.id, c);
    });
    return [...byId.values()];
  }, [categories]);

  return (
    <FilterButtonsContainer>
      <FilterButton
        selected={selectedCategoryId === "all"}
        onClick={() => setSelectedCategoryId("all")}
      >
        <FormattedMessage id={"all"} />
      </FilterButton>
      {uniqueCategories.map((category) => (
        <FilterButton
          key={category.id}
          selected={selectedCategoryId === category.id}
          onClick={() =>
            setSelectedCategoryId((prev) =>
              prev === category.id ? "all" : category.id
            )
          }
        >
          {category[intl.locale]}
        </FilterButton>
      ))}
    </FilterButtonsContainer>
  );
}

function PreviewCheckout({ cartProducts = [], productsToSell = [], currency }) {
  const [loading, setLoading] = useState(false);
  const [inputText, setInputText] = useState("");
  const [coupon, setCoupon] = useState(null);

  const focusedCodeRef = useRef(null);
  const intl = useIntl();
  const history = useHistory();
  const dispatch = useDispatch();
  const { token } = useSelector((state) => state.auth);
  const userId = localStorage.getItem("serviceSystemUserId");
  const opportunityId = localStorage.getItem("serviceOpportunityId");
  const eventId = localStorage.getItem("serviceEventId");

  const handleQTYChanges = ({ code, qty }) => {
    // Fazer uma cópia profunda do array para evitar mutações acidentais
    const newProducts = productsToSell.map((product) => ({ ...product }));
    const productIndex = newProducts.findIndex((p) => p.code === code);

    if (productIndex === -1) {
      console.warn(`Produto com código ${code} não encontrado`);
      return;
    }

    // Garantir que qty seja um número válido
    const validQty = qty === null || qty === undefined ? 0 : Number(qty);

    // Verificar se o valor é um número válido
    if (isNaN(validQty) || validQty < 0) {
      newProducts[productIndex].qty = 0;
    } else {
      newProducts[productIndex].qty = validQty;
    }

    return dispatch(
      updateAvaliableProducts({
        // Mantém no carrinho o produto cujo input está em foco, mesmo com qty 0,
        // para o usuário poder limpar e redigitar sem perder o item.
        cart: newProducts.filter(
          (p) => p.qty > 0 || p.code === focusedCodeRef.current
        ),
        products: newProducts,
      })
    );
  };

  const handleQtyBlur = () => {
    focusedCodeRef.current = null;
    const newProducts = productsToSell.map((product) => ({ ...product }));
    dispatch(
      updateAvaliableProducts({
        cart: newProducts.filter((p) => p.qty > 0),
        products: newProducts,
      })
    );
  };

  const total = useMemo(() => {
    return cartProducts.reduce((acc, curr) => acc + curr.value * curr.qty, 0);
  }, [cartProducts]);

  const handleToCheckout = async () => {
    if (cartProducts.length === 0) return;
    try {
      setLoading(true);
      const options = generateHeaders(token);

      const body = JSON.stringify({
        userId,
        opportunityId,
        eventId,
        discountCoupon: coupon?.trim() || null,
        products: cartProducts.map((p) => ({
          codigoProduto: p.code,
          quantidade: p.qty,
        })),
      });

      const response = await api.post(
        "/admin/ecommerce/post-cart",
        body,
        options
      );
      const { data } = response;
      const { ecommerceChlebaPostCartOutput } = data;
      dispatch(checkoutInfo({ data: ecommerceChlebaPostCartOutput }));

      history.push("/staff-access/services/sales/checkout");
      setLoading(false);
    } catch (error) {
      notification.error({
        message: intl.formatMessage({ id: "error" }),
        description: getEcommerceErrorDescription(intl, error, "api.error.-18026"),
      });
      setLoading(false);
    }
  };

  return (
    <CheckoutPreview>
      {cartProducts.length === 0 && <EmptyCheckout />}
      {cartProducts.length > 0 && (
        <CheckoutItemsContainer>
          {cartProducts.map((p) => (
            <ProductInfo
              key={`checkout-${p.code}`}
              checkout
              desc={formatCurrency({
                value: p.value,
                locale: intl.locale,
                currency: p.currency,
              })}
              name={p.title[intl.locale]}
              src={null}
              qtd={p.qty}
              onFocus={() => {
                focusedCodeRef.current = p.code;
              }}
              onBlur={handleQtyBlur}
              onChange={(qty) => {
                const validQty =
                  qty === null || qty === undefined ? 0 : Number(qty);
                const finalQty = isNaN(validQty) ? 0 : validQty;

                handleQTYChanges({
                  qty: finalQty,
                  code: p.code,
                });
              }}
            />
          ))}
        </CheckoutItemsContainer>
      )}
      <CheckoutFooter noBorder={cartProducts.length === 0}>
        {cartProducts.length > 0 && (
          <>
            <CouponContainer>
              <p>
                <FormattedMessage id={"coupon"} />
              </p>

              {!coupon && (
                <div>
                  <CouponInput
                    onChange={(e) => setInputText(e.target.value)}
                    onKeyDown={(e) => {
                      if (e.key === "Enter") {
                        setCoupon(inputText);
                      }
                    }}
                    placeholder={intl.formatMessage({ id: "enter_coupon" })}
                  />

                  <CouponButton
                    onClick={() => {
                      setCoupon(inputText);
                    }}
                    disabled={inputText.length === 0}
                  >
                    <CouponIcon size={20} />
                  </CouponButton>
                </div>
              )}

              {coupon && (
                <Coupon>
                  <div>
                    <CouponIcon size={18} color="#002244" />
                    <p>{coupon}</p>
                  </div>
                  <button
                    onClick={() => {
                      setInputText("");
                      setCoupon(null);
                    }}
                  >
                    <CancelIcon color="rgb(160, 36, 36)" />
                  </button>
                </Coupon>
              )}
            </CouponContainer>
            <div className="subtotal">
              <p>Subtotal</p>
              <p>
                {formatCurrency({
                  value: total,
                  locale: intl.locale,
                  currency,
                })}
              </p>
            </div>
          </>
        )}
        <CheckoutButton
          loading={loading}
          disabled={cartProducts.length === 0}
          onClick={handleToCheckout}
        >
          <FormattedMessage id="checkout" />
        </CheckoutButton>
      </CheckoutFooter>
    </CheckoutPreview>
  );
}

function EmptyCheckout() {
  return (
    <CheckoutEmpty>
      <BagIcon />
      <div>
        <p>
          <FormattedMessage id={"empty_bag"} />
        </p>
        <span>
          <FormattedMessage id={"empty_bag_desc"} />
        </span>
      </div>
    </CheckoutEmpty>
  );
}

function ProductsTable({ productsToSell = [], productsLoaded, data = [] }) {
  const dispatch = useDispatch();
  const [open, setOpen] = useState(false);
  const [productInfo, setProductInfo] = useState(null);
  const intl = useIntl();

  const columns = useMemo(
    () => [
      {
        header: intl.formatMessage({
          id: "product",
        }),
        id: 1,
        first: true,
      },
      {
        header: intl.formatMessage({
          id: "unitary_price",
        }),
        id: 2,
      },
      {
        header: intl.formatMessage({
          id: "quantity",
        }),
        id: 3,
      },
      {
        header: intl.formatMessage({
          id: "total_value",
        }),
        id: 4,
      },
    ],
    [intl]
  );

  const handleQTYChanges = ({ method = "ADD", code }) => {
    // Fazer uma cópia profunda do array para evitar mutações acidentais
    const newProducts = productsToSell.map((product) => ({ ...product }));
    const productIndex = newProducts.findIndex((p) => p.code === code);

    if (productIndex === -1) {
      console.warn(`Produto com código ${code} não encontrado na tabela`);
      return;
    }

    if (method === "SUB") {
      newProducts[productIndex].qty = Math.max(
        0,
        newProducts[productIndex].qty - 1
      );
    }

    if (method === "ADD") {
      newProducts[productIndex].qty = newProducts[productIndex].qty + 1;
    }

    if (productInfo) {
      setProductInfo(null);
      setOpen(false);
    }

    return dispatch(
      updateAvaliableProducts({
        cart: newProducts.filter((p) => p.qty > 0),
        products: newProducts,
      })
    );
  };

  const handleOpenModal = ({ acquiredInContract, code, name }) => {
    if (!acquiredInContract)
      return handleQTYChanges({
        code,
      });

    setProductInfo({
      code,
      name,
    });

    setOpen(true);
  };

  return (
    <ProductTableContainer>
      <ProductTableGrid header>
        {columns.map((col) => (
          <ProductColumnHeader key={col.id} first={col.first}>
            {col.header}
          </ProductColumnHeader>
        ))}
      </ProductTableGrid>
      {!productsLoaded && <TableItemsSkel />}

      {productsLoaded && data.length === 0 && <Empty />}
      {productsLoaded &&
        data.length > 0 &&
        data.map((p) => (
          <ProductTableGrid
            key={p.code}
            style={{
              animation: "fadeIn 0.5s ease-in-out",
              opacity: 1,
            }}
          >
            <ProductTableItem first>
              <ProductInfo
                desc={p.desc[intl.locale]}
                name={p.title[intl.locale]}
                src={null}
              />
            </ProductTableItem>

            <ProductTableItem>
              <Currency>
                {formatCurrency({
                  value: p.value,
                  locale: intl.locale,
                  currency: p.currency,
                })}
              </Currency>
            </ProductTableItem>

            <ProductTableItem>
              <ProductChangeQty>
                <MinusIcon
                  disabled={p.qty === 0}
                  onClick={() =>
                    handleQTYChanges({ code: p.code, method: "SUB" })
                  }
                />
                {p.qty}
                <PlusIcon
                  onClick={() =>
                    handleOpenModal({
                      acquiredInContract: p.acquiredInContract,
                      code: p.code,
                      name: p.title[intl.locale],
                    })
                  }
                />
              </ProductChangeQty>
            </ProductTableItem>

            <ProductTableItem>
              <Currency bold>
                {formatCurrency({
                  value: p.value * p.qty,
                  locale: intl.locale,
                  currency: p.currency,
                })}
              </Currency>
            </ProductTableItem>
          </ProductTableGrid>
        ))}

      <Modal
        open={open}
        width={"498px"}
        onCancel={() => setOpen(false)}
        footer={""}
        closable={false}
      >
        <AttentionIcon size={80} />
        <ModalWrapper>
          <ModalText type="title">
            <FormattedMessage id="product_acquired_contract" />
          </ModalText>
          <ModalText type="sub">
            <FormattedMessage
              id="product_already_owned"
              values={{ product: productInfo?.name ?? "" }}
            />
          </ModalText>
        </ModalWrapper>
        <ModalWrapper buttons>
          <ModalButton
            onClick={() => {
              handleQTYChanges({
                code: productInfo?.code,
              });
            }}
          >
            <FormattedMessage id="add" />
          </ModalButton>
          <ModalButton cancel onClick={() => setOpen(false)}>
            <FormattedMessage id="cancel" />
          </ModalButton>
        </ModalWrapper>
      </Modal>
    </ProductTableContainer>
  );
}

function TableItemsSkel() {
  return Array.from({ length: 15 }).map((p, i) => (
    <ProductTableGrid
      key={i}
      style={{
        animation: "fadeIn 0.5s ease-in-out",
        opacity: 1,
      }}
    >
      <ProductTableItem first>
        <ProductInfoSkeleton maxW={160} minW={100} threeLines={false} />
      </ProductTableItem>

      <ProductTableItem>
        <SkeletonDiv width="75px" height="20px" />
      </ProductTableItem>

      <ProductTableItem>
        <ProductChangeQty>
          <MinusIcon disabled />
          {0}
          <PlusIcon disabled />
        </ProductChangeQty>
      </ProductTableItem>

      <ProductTableItem>
        <SkeletonDiv width="75px" height="20px" />
      </ProductTableItem>
    </ProductTableGrid>
  ));
}
